<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>I am Einhard, some call me Eginhard, and I was born in the year of our Lord 770 in the land of the Eastern Franks in Maingau to Einhart and Engilfrit.</p>
<p>In this year of 830, I have retired to Mühlheim and it has befallen on me to recount the life of my most revered and great lord, the Christian Emperor Charlemagne, Charles the Great, Carolus Magnus, King of the Franks.</p>
<p>I am now of the age sixty years and first came to the Royal Court in 791 when I was twenty-one years. This was at a time when the king’s own family conspired against him but let me first take you to the magnificent sight as he was crowned.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?142053af